import cn from 'classnames/bind'

import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
import Sticky from 'app/common/templates-next/sticky'

import styles from './Header.module.scss'
import { EncashmentsAction } from 'app/dataTypes/reports/data/finances/encashments/action'


const cx = cn.bind(styles)

type Props = {
  showRecordButton: boolean
  showCancelButton: boolean
  onSelectionMode: (mode: EncashmentsAction) => void
  disabled: boolean
}

export const Header = ({ showRecordButton, showCancelButton, onSelectionMode, disabled }: Props) => {
  return (
    <Sticky resetShift={showRecordButton || showCancelButton}>
      {(ref, stuck) => (
        (showRecordButton || showCancelButton) &&
        <div className={cx(styles.root, { stuck })} ref={ref}>
          {showRecordButton
            && <PlainButtonAsLink
              className={styles.item}
              onClick={() => onSelectionMode(EncashmentsAction.Accept)}
              disabled={disabled}
              linkClassName={styles.acceptBtn}
            >
              {'Выбрать заведения для подтверждения принятия наличных'}
            </PlainButtonAsLink>}

          {showCancelButton
            && <PlainButtonAsLink
              className={styles.item}
              onClick={() => onSelectionMode(EncashmentsAction.Reject)}
              disabled={disabled}
              linkClassName={styles.rejectBtn}
            >
              {'Выбрать заведения для отказа принятия наличных'}
            </PlainButtonAsLink>}

          {!showRecordButton
            && !showCancelButton
            && <span>&nbsp;</span>}
        </div>
      )}
    </Sticky>
  )
}
